/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_Send_CaptionInputs */

const en_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A small JSON body. The values shown are examples to replace with your own.`)
};

const zh_hans1_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个简短的 JSON 请求体。显示的值只是示例，请换成你自己的。`)
};

const pt_br2_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um corpo JSON pequeno. Os valores mostrados são exemplos para você trocar pelos seus.`)
};

const es_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un cuerpo JSON pequeño. Los valores que se muestran son ejemplos para reemplazar por los tuyos.`)
};

const fr_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un petit corps JSON. Les valeurs affichées sont des exemples à remplacer par les vôtres.`)
};

const de_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein kleiner JSON-Body. Die gezeigten Werte sind Beispiele, die du durch deine eigenen ersetzt.`)
};

const ru_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Небольшое тело JSON. Показанные значения это примеры, замените их своими.`)
};

const it_endpoint_reference_send_caption = /** @type {(inputs: Endpoint_Reference_Send_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un piccolo corpo JSON. I valori mostrati sono esempi da sostituire con i tuoi.`)
};

/**
* | output |
* | --- |
* | "A small JSON body. The values shown are examples to replace with your own." |
*
* @param {Endpoint_Reference_Send_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_send_caption = /** @type {((inputs?: Endpoint_Reference_Send_CaptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Send_CaptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_send_caption(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_send_caption(inputs)
	if (locale === "es") return es_endpoint_reference_send_caption(inputs)
	if (locale === "fr") return fr_endpoint_reference_send_caption(inputs)
	if (locale === "de") return de_endpoint_reference_send_caption(inputs)
	if (locale === "ru") return ru_endpoint_reference_send_caption(inputs)
	if (locale === "it") return it_endpoint_reference_send_caption(inputs)
	return en_endpoint_reference_send_caption(inputs)
});